import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Circle } from '../IconBase/IconBase'

function Dots({ color = 'icon.primary', ...props }) {
  return (
    <IconBase viewBox='0 0 3 15' {...props}>
      <Circle cx='1.5' cy='1.5' r='1.5' fill={color} />
      <Circle cx='1.5' cy='7.5' r='1.5' fill={color} />
      <Circle cx='1.5' cy='13.5' r='1.5' fill={color} />
    </IconBase>
  )
}

Dots.propTypes = {
  color: PropTypes.string,
}

export default Dots
